// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "v-calendar/lib/v-calendar.min.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./assets/css/session-warning.css";

import Vue from "vue";
import { mapActions } from "vuex";

import BootstrapVue from "bootstrap-vue";
import Notifications from "vue-notification";

import Pitaya from "./App";
import { router } from "./router";
import { store } from "./modules/index";
import Vuelidate from "vuelidate";
import VueProgressBar from "vue-progressbar";
import { StripeCheckout } from "vue-stripe-elements-plus";

import groupBy from "lodash.groupby";
import * as VueGoogleMaps from "vue2-google-maps";
import ToggleButton from "vue-js-toggle-button";
import VCalendar from "v-calendar";
import moment from "moment";
import VueSelect from "vue-cool-select";
import VueClipboard from "vue-clipboard2";
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");

VueClipboard.config.autoSetContainer = true; // This makes it work in modals

import VueSweetalert2 from "vue-sweetalert2";
import VueMultiselect from "vue-multiselect";

import "./plugins/axios";

Vue.use(VueTour);
Vue.use(VueSweetalert2);
Vue.component("vue-multiselect", VueMultiselect);

// Use v-calendar, v-date-picker & v-popover components
switch (localStorage.getItem("locale")) {
  case "es":
    Vue.use(VCalendar, {
      locale: "es", // Spanish
      firstDayOfWeek: 1, // Sunday
    });

    break;

  case "en":
    Vue.use(VCalendar, {
      locale: "en", // English
      firstDayOfWeek: 2, // Monday
    });
    break;

  case "xx":
    Vue.use(VCalendar, {
      locale: "es", // Spanish
      firstDayOfWeek: 1, // Sunday
    });
    break;

  default:
    Vue.use(VCalendar, {
      locale: "en",
      firstDayOfWeek: 2,
    });
    break;
}

Vue.use(ToggleButton);

Vue.use(VueSelect, { theme: "bootstrap" });
Vue.use(Vuelidate);
Vue.use(VueProgressBar, {
  color: "#587294",
  failedColor: "red",
  height: "4px",
  zIndex: 2000,
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 400,
  },
});

Vue.component("stripe-checkout", StripeCheckout);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg",
    libraries: "places",
  },
});

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueClipboard);
Vue.config.productionTip = false;

moment.locale("en-us");
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$groupBy", { value: groupBy });

Vue.mixin({
  methods: {
    ...mapActions([
      "successNotification",
      "errorNotification",
      "infoNotification",
    ]),
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#pitaya",
  router,
  store,
  components: { Pitaya },
  template: "<Pitaya/>",
  created() {
    // Fetch subscription data on initial app load if already authenticated
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch("subscription/fetchSubscriptionData");
    }
  },
});
